<template>
  <div class="foot_main">
    <div class="foot_cont_info">
      <div class="top_cont_data">
        <p class="logo">
          <img src="@/assets/pc/logo2.png" /><span>大国工匠人才培育工程</span>
        </p>
        <div class="cont_menu_data">
          <ul>
            <p class="text" @click="$router.push('/courseList')">课程专区</p>
            <!-- <li @click="goNextUrl('/collegeInfo')">热点话题</li> -->
          </ul>
          <ul>
            <p class="text" @click="$router.push('/clearinghouse')">交流专区</p>
          </ul>
          <ul>
            <p class="text" @click="$router.push('/rankList')">学习积分</p>
          </ul>
        </div>
      </div>
      <div class="code_text">
        <span>大国工匠人才培育平台 中国劳动关系学院 版权所有 联系电话：01088561641</span>
        <span>技术支持：常老师 15701207563</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  data() {
    return {};
  },
  props: {},
  watch: {
    $route: {
      handler(newVal) {},
      immediate: true,
    },
  },
  mounted() {},
  methods: {
    goNextUrl(url) {
      this.$router.push({ path: url });
    },
    showcaseJump(url) {
      let userInfo = JSON.parse(localStorage.getItem("userInfo"));

      if (userInfo && userInfo.identity_type == 2) {
        this.$router.push(url);
      } else {
        this.$message.warning("成为工匠学院学员，即可使用此功能");
      }
    },
  },
};
</script>

<style scoped lang="scss">
.foot_main {
  background-color: #262626;
  .foot_cont_info {
    width: 1200px;
    margin: 0 auto;
    padding: 60px 0 0;
    .top_cont_data {
      display: flex;
      p.logo {
        // width: 199px;
        display: flex;
        align-items: center;
        margin-bottom: auto;
        img {
          width: 46px;
          height: 46px;
        }
        span {
          font-family: "PingFangSC-Regular";
          font-size: 24px;
          color: rgba(255, 255, 255, 0.75);
          margin-left: 15px;
        }
      }
      .cont_menu_data {
        flex: 1;
        margin-left: 108px;
        display: flex;
        ul {
          margin-right: 136px;
          p.text {
            font-size: 18px;
            color: rgba(255, 255, 255, 0.75);
            line-height: 46px;
            cursor: pointer;
          }
          li {
            font-size: 14px;
            color: rgba(255, 255, 255, 0.75);
            margin-top: 26px;
            cursor: pointer;
          }
        }
        ul:last-child {
          margin-right: 0;
        }
      }
    }
    .code_text {
      padding: 20px 0;
      border-top: 1px solid #cacaca;
      font-size: 12px;
      color: rgba(255, 255, 255, 0.75);
      text-align: center;
      margin-top: 20px;
      span {
        margin: 0 10px;
      }
    }
  }
}
</style>
